import { createReducer } from './utils';
import { clearAbort, createAbort, ABORT_KEYS } from './utils/abortManager';
import {
  RESOURCES_OVERHEAD_FAILURE,
  RESOURCES_OVERHEAD_LOADING,
  RESOURCES_OVERHEAD_SUCCESS,
} from './constants';

const defaultState = {
  loading: false,
  hasOverhead: false,
  errorMessage: null,
};

export const reducer = createReducer(defaultState, {
  [RESOURCES_OVERHEAD_LOADING]: handleLoading,
  [RESOURCES_OVERHEAD_SUCCESS]: handleSuccess,
  [RESOURCES_OVERHEAD_FAILURE]: handleFailure,
});

function handleLoading(state) {
  return { ...state, loading: true };
}

function handleSuccess(state, { payload: { hasOverhead } }) {
  return { ...state, loading: false, hasOverhead };
}

function handleFailure(state, { payload: { error } }) {
  return { ...state, loading: false, errorMessage: error };
}

export function getResourcesOverhead() {
  return async (dispatch, getState, { services: { dataSource } }) => {
    dispatch({ type: RESOURCES_OVERHEAD_LOADING });

    const {
      stores: { currentStore },
      tasks: { currentTaskType },
    } = getState();

    try {
      const signal = createAbort(ABORT_KEYS.RESOURCES_OVERHEAD);
      const response = await dataSource.requestResourcesOverhead({
        store: currentStore,
        task_type: currentTaskType,
        signal,
      });
      clearAbort(ABORT_KEYS.RESOURCES_OVERHEAD);

      dispatch({
        type: RESOURCES_OVERHEAD_SUCCESS,
        payload: { hasOverhead: !!response?.has_overhead },
      });
    } catch (error) {
      if (error.name === 'AbortError') return;
      dispatch({
        type: RESOURCES_OVERHEAD_FAILURE,
        payload: { error },
      });
    }
  };
}
